import React from 'react';
import { matchPath, useLocation, useHistory } from 'react-router';
import { APP_ROUTES } from '../../../../routing/AppRoutes';
import { LinearNavigationTabs } from '../../../../components/common/tabs/LinearTabs/LinearTabs';
import clsx from 'clsx';
import { BaseTypography } from '../../../../components/common';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

const useStyles = makeStyles((theme) => ({
  tabsWrapper: {
    margin: '0 0 20px',
  },
  step: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '40px max-content',
    gridGap: '10px',
    cursor: 'pointer',
  },
  step__number: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    height: '40px',
    background: '#EBEBEB',
    color: 'white',
    borderRadius: '50%',
  },
  step_active: {
    background: theme.palette.primary.main,
  },
}));

type PStep = {
  number: number;
  label: string;
  isActive?: boolean;
  dynamicPath?: string;
};

const Step: React.FC<PStep> = (props) => {
  const { number, label, isActive, dynamicPath } = props;
  const classes = useStyles();
  const history = useHistory();
  const storedGuest = useSelector(
    (state: RootState) => state.createGuest.guest,
  );

  const handleClick = () => {
    if (number === 1) {
      history.push(dynamicPath);
    }
    if (number === 2 && storedGuest) {
      history.push(dynamicPath);
    }
  };

  return (
    <div className={clsx(classes.step)} onClick={handleClick}>
      <BaseTypography
        variant="h4"
        className={clsx(classes.step__number, isActive && classes.step_active)}
      >
        {number}
      </BaseTypography>
      <span>{label}</span>
    </div>
  );
};

type PCreateGuestTabs = {
  creationOfGuestPath: string;
  uploadingOfGuestPath: string;
};

export const CreateGuestTabs: React.FC<PCreateGuestTabs> = (props) => {
  const location = useLocation();
  const { creationOfGuestPath, uploadingOfGuestPath } = props;
  const matchUploadMediaPath = matchPath(location.pathname, {
    path: uploadingOfGuestPath,
    exact: false,
    strict: false,
  });

  const list = [
    {
      value: creationOfGuestPath,
      label: (
        <Step
          number={1}
          label="General Information"
          isActive={
            location.pathname === APP_ROUTES.CREATE_GUEST ||
            location.pathname === APP_ROUTES.CREATE_CONTACT
          }
          dynamicPath={creationOfGuestPath}
        />
      ),
      locked: true,
    },
    {
      value: uploadingOfGuestPath,
      label: (
        <Step
          dynamicPath={uploadingOfGuestPath}
          number={2}
          label="Guest image & Embed video"
          isActive={Boolean(matchUploadMediaPath)}
        />
      ),
      locked: true,
    },
  ];
  return <LinearNavigationTabs currentPath={location.pathname} tabs={list} />;
};
